import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'react-orange-ui';
import { Link } from 'react-onei';

import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';

function ConfidentialMessage({ webViewFlag }) {
    const handleClick = () => {
        TagService.sendAction('phishingInfo');
    };

    return (
        <div style={{ marginTop: 20 }}>
            <Text id="password-best-practices">
                {WordingService.getWording('caption', 'phishing')}
            </Text>
            { !webViewFlag && (
                <Link
                    id="link-phishing-info"
                    href={window.reactAppEnv.href.phishingInfo}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleClick}
                    aria-label="Plus d’infos sur le phishing"
                    title="Plus d’infos sur le phishing"
                >
                    {WordingService.getWording('url', 'phishing')}
                </Link>
            )}
        </div>
    );
}

ConfidentialMessage.defaultProps = {
    webViewFlag: false,
};

ConfidentialMessage.propTypes = {
    /** Flag to know if the app is in webView Mode */
    webViewFlag: PropTypes.bool,
};

export default ConfidentialMessage;